import { Component, Input } from '@angular/core';

@Component({
  selector: 'sp-tooltip',
  templateUrl: 'tooltip.component.html',
  styleUrls: ['tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() message = '';
  constructor() {}
}
